<template>
  <div class="col-lg-12 pb-4">
    <div class="card">
      <div class="card-body border">
        <div v-if="website">
          <b-tabs
            content-class="crypto-buy-sell-nav-content"
            nav-class="nav-tabs-custom"
          >
            <b-tab title="Summary">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-7">
                      <h6 class="py-1">
                        {{ $t("overview.basic-information") }}
                      </h6>
                      <table class="table" v-if="webinfo">
                        <tr v-if="webinfo.domain_name">
                          <th width="25%" class="text-left">
                            {{ $t("website.domain_name") }}
                          </th>
                          <td width="70%">
                            <a
                              :href="'https://' + webinfo.domain_name"
                              target="_blank"
                            >
                              {{ webinfo.domain_name }}
                            </a>
                          </td>
                        </tr>
                        <tr v-if="webinfo.ip_address">
                          <th width="25%" class="text-left">
                            {{ $t("website.ip") }}
                          </th>
                          <td width="70%">{{ webinfo.ip_address }}</td>
                        </tr>
                        <tr v-if="webinfo.visitors">
                          <th width="25%" class="text-left">
                            {{ $t("website.visitors") }}
                          </th>
                          <td>{{ webinfo.visitors }}</td>
                        </tr>
                        <tr v-if="webinfo.ip_location">
                          <th width="25%" class="text-left">
                            {{ $t("website.ip_location") }}
                          </th>
                          <td>{{ webinfo.ip_location }}</td>
                        </tr>
                        <tr v-if="webinfo.ip_reverse_dns">
                          <th width="25%" class="text-left">
                            {{ $t("website.ip_reserve_dns") }}
                          </th>
                          <td>{{ webinfo.ip_reverse_dns }}</td>
                        </tr>
                        <tr v-if="webinfo.hosting_company">
                          <th width="25%" class="text-left">
                            {{ $t("website.hosting_company") }}
                          </th>
                          <td>{{ webinfo.hosting_company }}</td>
                        </tr>
                        <tr v-if="webinfo.hosting_ip_range">
                          <th width="25%" class="text-left">
                            {{ $t("website.hosting_ip_range") }}
                          </th>
                          <td>{{ webinfo.hosting_ip_range }}</td>
                        </tr>
                        <tr v-if="webinfo.hosting_address">
                          <th width="25%" class="text-left">
                            {{ $t("website.hosting_address") }}
                          </th>
                          <td>{{ webinfo.hosting_address }}</td>
                        </tr>
                        <tr v-if="webinfo.hosting_country">
                          <th width="25%" class="text-left">
                            {{ $t("website.hosting_country") }}
                          </th>
                          <td>{{ webinfo.hosting_country }}</td>
                        </tr>
                        <tr v-if="webinfo.hosting_phone">
                          <th width="25%" class="text-left">
                            {{ $t("website.hosting_phone") }}
                          </th>
                          <td>{{ webinfo.hosting_phone }}</td>
                        </tr>
                        <tr v-if="webinfo.cidr">
                          <th width="25%" class="text-left">
                            {{ $t("website.cidr") }}
                          </th>
                          <td>{{ webinfo.cidr }}</td>
                        </tr>
                        <tr v-if="webinfo.hosting_cidr">
                          <th width="25%" class="text-left">
                            {{ $t("website.hosting_cidr") }}
                          </th>
                          <td>{{ webinfo.hosting_cidr }}</td>
                        </tr>
                      </table>
                    </div>
                    <div class="col-sm-5">
                      <div class="card" v-if="iplocation">
                        <gmap-map
                          ref="mymap"
                          :center="{
                            lat: parseFloat(iplocation.latitude),
                            lng: parseFloat(iplocation.longitude),
                          }"
                          :zoom="4"
                          style="height: 40vh"
                        >
                          <gmap-marker
                            :position="
                              google &&
                              new google.maps.LatLng(
                                iplocation.latitude,
                                iplocation.longitude
                              )
                            "
                          ></gmap-marker>
                        </gmap-map>
                      </div>
                      <div class="card border pt-2 mt-3" v-if="iplocation">
                        <h5 class="px-3 py-1">{{ $t("website.geo") }}</h5>
                        <table class="table">
                          <tr>
                            <th width="25%" class="text-left">
                              {{ $t("website.city") }}
                            </th>
                            <td>{{ iplocation.region }}</td>
                          </tr>
                          <tr>
                            <th width="25%" class="text-left">
                              {{ $t("website.country_name") }}
                            </th>
                            <td>
                              {{ iplocation.country_name }} ({{
                                iplocation.country_code
                              }})
                            </td>
                          </tr>
                          <tr>
                            <th width="25%" class="text-left">
                              {{ $t("website.coordinates") }}
                            </th>
                            <td>
                              {{ iplocation.latitude }},
                              {{ iplocation.longitude }}
                            </td>
                          </tr>
                          <tr>
                            <th width="25%" class="text-left">
                              {{ $t("website.timezone") }}
                            </th>
                            <td>{{ iplocation.timezone }}</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>

            <b-tab title="IP Location">
              <div class="card h-100">
                <div class="py-4">
                  <div class="row mt-2" v-if="iplocation">
                    <div class="col-sm-7">
                      <div class="py-0 px-3">
                        <p v-if="iplocation.ip_address">
                          <b>{{ $t("website.ip") }} :</b>
                          {{ iplocation.ip_address }}
                        </p>
                        <p v-if="iplocation.domain_name">
                          <b>{{ $t("website.domain_name") }} :</b>
                          {{ iplocation.domain_name }}
                        </p>
                        <p v-if="iplocation.version">
                          <b>{{ $t("website.version") }} :</b>
                          {{ iplocation.version }}
                        </p>
                        <p v-if="iplocation.city">
                          <b>{{ $t("website.city") }}:</b> {{ iplocation.city }}
                        </p>
                        <p v-if="iplocation.region">
                          <b>{{ $t("website.region") }}:</b>
                          {{ iplocation.region }}
                        </p>
                        <p v-if="iplocation.region_code">
                          <b>{{ $t("website.region_code") }}:</b>
                          {{ iplocation.region_code }}
                        </p>
                        <p v-if="iplocation.icountryp">
                          <b>{{ $t("website.country") }}:</b>
                          {{ iplocation.country }}
                        </p>
                        <p v-if="iplocation.country_name">
                          <b>{{ $t("website.country_name") }}:</b>
                          {{ iplocation.country_name }}
                        </p>
                        <p v-if="iplocation.country_code">
                          <b>{{ $t("website.country_code") }}:</b>
                          {{ iplocation.country_code }}
                        </p>
                        <p v-if="iplocation.country_code_iso3">
                          <b>{{ $t("website.country_code_iso3") }}:</b>
                          {{ iplocation.country_code_iso3 }}
                        </p>
                        <p v-if="iplocation.country_capital">
                          <b>{{ $t("website.country_capital") }}y:</b>
                          {{ iplocation.country_capital }}
                        </p>
                        <p v-if="iplocation.country_tld">
                          <b>{{ $t("website.country_tld") }}e:</b>
                          {{ iplocation.country_tld }}
                        </p>
                        <p v-if="iplocation.continent_code">
                          <b>{{ $t("website.continent_code") }}:</b>
                          {{ iplocation.continent_code }}
                        </p>
                        <p v-if="iplocation.in_eu">
                          <b>{{ $t("website.in_eu") }}:</b>
                          {{ iplocation.in_eu }}
                        </p>
                        <p v-if="iplocation.postal">
                          <b>{{ $t("website.postal") }}:</b>
                          {{ iplocation.postal }}
                        </p>
                        <p v-if="iplocation.utc_offset">
                          <b>{{ $t("website.utc_offset") }}:</b>
                          {{ iplocation.utc_offset }}
                        </p>
                        <p v-if="iplocation.country_calling_code">
                          <b>{{ $t("website.country_calling_code") }}:</b>
                          {{ iplocation.country_calling_code }}
                        </p>
                        <p v-if="iplocation.currency">
                          <b>{{ $t("website.currency") }}s </b>,
                          {{ iplocation.currency }}n
                        </p>
                        <p v-if="iplocation.currency_name">
                          <b>{{ $t("website.currency_name") }}:</b>
                          {{ iplocation.currency_name }}
                        </p>
                        <p v-if="iplocation.languages">
                          <b>{{ $t("website.languages") }}:</b>
                          {{ iplocation.languages }}
                        </p>
                        <p v-if="iplocation.country_area">
                          <b>{{ $t("website.country_area") }}:</b>
                          {{ iplocation.country_area }}
                        </p>
                        <p v-if="iplocation.asn">
                          <b>{{ $t("website.asn") }}:</b> {{ iplocation.asn }}
                        </p>
                        <p v-if="iplocation.org">
                          <b>{{ $t("website.org") }}:</b> {{ iplocation.org }}
                        </p>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <div class="card" v-if="iplocation.latitude">
                        <gmap-map
                          ref="mymap"
                          :center="{
                            lat: parseFloat(iplocation.latitude),
                            lng: parseFloat(iplocation.longitude),
                          }"
                          :zoom="4"
                          style="height: 40vh"
                        >
                          <gmap-marker
                            :position="
                              google &&
                              new google.maps.LatLng(
                                iplocation.latitude,
                                iplocation.longitude
                              )
                            "
                          ></gmap-marker>
                        </gmap-map>
                      </div>
                      <div
                        class="card border pt-2 mt-3"
                        v-if="iplocation.latitude"
                      >
                        <h5 class="px-3 py-1">{{ $t("website.geo") }}</h5>
                        <table class="table">
                          <tr>
                            <th width="25%" class="text-left">
                              {{ $t("website.city") }}
                            </th>
                            <td>{{ iplocation.region }}</td>
                          </tr>
                          <tr>
                            <th width="25%" class="text-left">
                              {{ $t("website.country_name") }}
                            </th>
                            <td>
                              {{ iplocation.country_name }} ({{
                                iplocation.country_code
                              }})
                            </td>
                          </tr>
                          <tr>
                            <th width="25%" class="text-left">
                              {{ $t("website.coordinates") }}
                            </th>
                            <td>
                              {{ iplocation.latitude }},
                              {{ iplocation.longitude }}
                            </td>
                          </tr>
                          <tr>
                            <th width="25%" class="text-left">
                              {{ $t("website.timezone") }}
                            </th>
                            <td>{{ iplocation.timezone }}</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                  <p
                    class="text-center p-5"
                    v-if="!iplocation && !results_location"
                  >
                    <b-button
                      class="btn btn-sm"
                      @click="searchLocation"
                      variant="primary"
                      v-if="
                        id_user === id_analys ||
                        id_user === manager ||
                        user_type === 'superadmin' ||
                        user_type === 'admin' ||
                        user_type === 'vvip'
                      "
                    >
                      <b-spinner
                        v-if="loading"
                        label="Loading ..."
                        small
                      ></b-spinner>
                      <span v-if="loading" class="ml-2">{{
                        $t("button.search.loading")
                      }}</span>
                      <span v-if="!loading"
                        ><i class="fas fa-search"></i>
                        {{ $t("website.get-data") }}
                      </span></b-button
                    >
                  </p>

                  <div class="row" v-if="results_location">
                    <div class="col-sm-6">
                      <div class="py-1 px-3">
                        <p v-if="results_location.ip">
                          Find Website / {{ $t("website.ip_location") }}
                        </p>
                        <p v-if="results_location.ip">
                          <b>{{ $t("website.ip") }} :</b>
                          {{ results_location.ip }}
                        </p>
                        <p v-if="results_location.version">
                          <b>{{ $t("website.version") }} :</b>
                          {{ results_location.version }}
                        </p>
                        <p v-if="results_location.city">
                          <b>{{ $t("website.city") }}:</b>
                          {{ results_location.city }}
                        </p>
                        <p v-if="results_location.region">
                          <b>{{ $t("website.region") }}:</b>
                          {{ results_location.region }}
                        </p>
                        <p v-if="results_location.region_code">
                          <b>{{ $t("website.region_code") }}:</b>
                          {{ results_location.region_code }}
                        </p>
                        <p v-if="results_location.icountryp">
                          <b>{{ $t("website.country") }}:</b>
                          {{ results_location.country }}
                        </p>
                        <p v-if="results_location.country_name">
                          <b>{{ $t("website.country_name") }}:</b>
                          {{ results_location.country_name }}
                        </p>
                        <p v-if="results_location.country_code">
                          <b>{{ $t("website.country_code") }}:</b>
                          {{ results_location.country_code }}
                        </p>
                        <p v-if="results_location.country_code_iso3">
                          <b>{{ $t("website.country_code_iso3") }}:</b>
                          {{ results_location.country_code_iso3 }}
                        </p>
                        <p v-if="results_location.country_capital">
                          <b>{{ $t("website.country_capital") }}y:</b>
                          {{ results_location.country_capital }}
                        </p>
                        <p v-if="results_location.country_tld">
                          <b>{{ $t("website.country_tld") }}e:</b>
                          {{ results_location.country_tld }}
                        </p>
                        <p v-if="results_location.continent_code">
                          <b>{{ $t("website.continent_code") }}:</b>
                          {{ results_location.continent_code }}
                        </p>
                        <p v-if="results_location.in_eu">
                          <b>{{ $t("website.in_eu") }}:</b>
                          {{ results_location.in_eu }}
                        </p>
                        <p v-if="results_location.postal">
                          <b>{{ $t("website.postal") }}:</b>
                          {{ results_location.postal }}
                        </p>
                        <p v-if="results_location.utc_offset">
                          <b>{{ $t("website.utc_offset") }}:</b>
                          {{ results_location.utc_offset }}
                        </p>
                        <p v-if="results_location.country_calling_code">
                          <b>{{ $t("website.country_calling_code") }}:</b>
                          {{ results_location.country_calling_code }}
                        </p>
                        <p v-if="results_location.currency">
                          <b>{{ $t("website.currency") }}s </b>,
                          {{ results_location.currency }}n
                        </p>
                        <p v-if="results_location.currency_name">
                          <b>{{ $t("website.currency_name") }}:</b>
                          {{ results_location.currency_name }}
                        </p>
                        <p v-if="results_location.languages">
                          <b>{{ $t("website.languages") }}:</b>
                          {{ results_location.languages }}
                        </p>
                        <p v-if="results_location.country_area">
                          <b>{{ $t("website.country_area") }}:</b>
                          {{ results_location.country_area }}
                        </p>
                        <p v-if="results_location.asn">
                          <b>{{ $t("website.asn") }}:</b>
                          {{ results_location.asn }}
                        </p>
                        <p v-if="results_location.org">
                          <b>{{ $t("website.org") }}:</b>
                          {{ results_location.org }}
                        </p>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="card" v-if="results_location.latitude">
                        <gmap-map
                          ref="mymap"
                          :center="{
                            lat: parseFloat(results_location.latitude),
                            lng: parseFloat(results_location.longitude),
                          }"
                          :zoom="4"
                          style="height: 40vh"
                        >
                          <gmap-marker
                            :position="
                              google &&
                              new google.maps.LatLng(
                                results_location.latitude,
                                results_location.longitude
                              )
                            "
                          ></gmap-marker>
                        </gmap-map>
                      </div>
                      <div
                        class="card border pt-2 mt-3"
                        v-if="results_location.latitude"
                      >
                        <h5 class="px-3 py-1">{{ $t("website.geo") }}</h5>
                        <table class="table">
                          <tr>
                            <th width="25%" class="text-left">
                              {{ $t("website.city") }}
                            </th>
                            <td>{{ results_location.region }}</td>
                          </tr>
                          <tr>
                            <th width="25%" class="text-left">
                              {{ $t("website.country_name") }}
                            </th>
                            <td>
                              {{ results_location.country_name }} ({{
                                results_location.country_code
                              }})
                            </td>
                          </tr>
                          <tr>
                            <th width="25%" class="text-left">
                              {{ $t("website.coordinates") }}
                            </th>
                            <td>
                              {{ results_location.latitude }},
                              {{ results_location.longitude }}
                            </td>
                          </tr>
                          <tr>
                            <th width="25%" class="text-left">
                              {{ $t("website.timezone") }}
                            </th>
                            <td>{{ results_location.timezone }}</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <!-- <div class="col-sm-12 text-left" v-if="results_location.ip">
                                            <b-button class="btn" variant="secondary" size="sm" @click="clearData"><i class="fa fa-times"></i> Clear</b-button> <b-button class="btn" variant="success" size="sm" @click="saveWebsiteInfoLocation"><i class="fa fa-check"></i> Save</b-button>
                                        </div>  -->
                  </div>
                </div>
              </div>
            </b-tab>

            <b-tab title="WHOIS">
              <div class="card h-100">
                <div class="py-4" v-if="whois">
                  <p v-if="whois.domain_name">
                    <b>{{ $t("website.domain_name") }}: </b>
                    {{ whois.domain_name }}
                  </p>
                  <p v-if="whois.created_date">
                    <b>{{ $t("website.created_date") }}: </b>
                    {{ whois.created_date }}
                  </p>
                  <p v-if="whois.expired_date">
                    <b>{{ $t("website.expired_date") }}: </b>
                    {{ whois.expired_date }}
                  </p>
                  <p v-if="whois.contact_email">
                    <b>{{ $t("website.contact_email") }}: </b>
                    {{ whois.contact_email }}
                  </p>
                  <p v-if="whois.registran_name">
                    <b>{{ $t("website.registran_name") }}: </b>
                    {{ whois.registran_name }}
                  </p>
                  <p v-if="whois.registran_organization">
                    <b>{{ $t("website.registrant_organization") }}: </b>
                    {{ whois.registran_organization }}
                  </p>
                  <p v-if="whois.registran_street">
                    <b>{{ $t("website.registran_street") }}: </b>
                    {{ whois.registran_street }}
                  </p>
                  <p v-if="whois.registran_city">
                    <b>{{ $t("website.registran_city") }}: </b>
                    {{ whois.registran_city }}
                  </p>
                  <p v-if="whois.registran_state">
                    <b>{{ $t("website.registran_state") }}: </b>
                    {{ whois.registran_state }}
                  </p>
                  <p v-if="whois.registran_postal_code">
                    <b>{{ $t("website.registran_postal_code") }}: </b>
                    {{ whois.registran_postal_code }}
                  </p>
                  <p v-if="whois.registran_country">
                    <b>{{ $t("website.registran_country") }}: </b>
                    {{ whois.registran_country }}
                  </p>
                  <p v-if="whois.registrant_countryCode">
                    <b>{{ $t("website.registran_country") }}: </b>
                    {{ whois.registrant_countryCode }}
                  </p>
                  <p v-if="whois.registran_email">
                    <b>{{ $t("website.registran_email") }}: </b>
                    {{ whois.registran_email }}
                  </p>
                  <p v-if="whois.registran_telephone">
                    <b>{{ $t("website.registran_phone") }}: </b>
                    {{ whois.registran_telephone }}
                  </p>
                  <p v-if="whois.registran_fax">
                    <b>{{ $t("website.registran_fax") }}: </b>
                    {{ whois.registran_fax }}
                  </p>
                  <p v-if="whois.admin_name">
                    ======================================================
                  </p>
                  <p v-if="whois.admin_name">
                    <b>{{ $t("website.admin_name") }}: </b>
                    {{ whois.admin_name }}
                  </p>
                  <p v-if="whois.admin_organization">
                    <b>{{ $t("website.admin_organization") }}: </b>
                    {{ whois.admin_organization }}
                  </p>
                  <p v-if="whois.admin_street">
                    <b>{{ $t("website.admin_street") }}: </b>
                    {{ whois.admin_street }}
                  </p>
                  <p v-if="whois.admin_city">
                    <b>{{ $t("website.admin_city") }}: </b>
                    {{ whois.admin_city }}
                  </p>
                  <p v-if="whois.admin_state">
                    <b>{{ $t("website.admin_state_provincie") }}: </b>
                    {{ whois.admin_state }}
                  </p>
                  <p v-if="whois.admin_postalCode">
                    <b>{{ $t("website.admin_postal_code") }}: </b>
                    {{ whois.admin_postalCode }}
                  </p>
                  <p v-if="whois.admin_host_contry">
                    <b>{{ $t("website.admin_country") }}: </b>
                    {{ whois.admin_host_contry }}
                  </p>
                  <p v-if="whois.admin_countryCode">
                    <b>{{ $t("website.admin_postal_code") }}: </b>
                    {{ whois.admin_countryCode }}
                  </p>
                  <p v-if="whois.admin_email">
                    <b>{{ $t("website.admin_phone") }}: </b>
                    {{ whois.admin_email }}
                  </p>
                  <p v-if="whois.admin_telephone">
                    <b>{{ $t("website.admin_phone") }}: </b>
                    {{ whois.admin_telephone }}
                  </p>
                  <p v-if="whois.admin_fax">
                    <b>{{ $t("website.admin_fax") }}: </b> {{ whois.admin_fax }}
                  </p>
                  <p v-if="whois.tech_name">
                    ======================================================
                  </p>
                  <p v-if="whois.tech_name">
                    <b>{{ $t("website.tech_name") }}: </b> {{ whois.tech_name }}
                  </p>
                  <p v-if="whois.tech_organization">
                    <b>{{ $t("website.tech_organization") }}: </b>
                    {{ whois.tech_organization }}
                  </p>
                  <p v-if="whois.tech_street">
                    <b>{{ $t("website.tech_street") }}: </b>
                    {{ whois.tech_street }}
                  </p>
                  <p v-if="whois.tech_city">
                    <b>{{ $t("website.tech_city") }}: </b> {{ whois.tech_city }}
                  </p>
                  <p v-if="whois.tech_state">
                    <b>{{ $t("website.tech_state_province") }}: </b>
                    {{ whois.tech_state }}
                  </p>
                  <p v-if="whois.tech_postalCode">
                    <b>{{ $t("website.tech_postal_code") }}: </b>
                    {{ whois.tech_postalCode }}
                  </p>
                  <p v-if="whois.tech_host_contry">
                    <b>{{ $t("website.tech_country") }}: </b>
                    {{ whois.tech_host_contry }}
                  </p>
                  <p v-if="whois.tech_countryCode">
                    <b>{{ $t("website.tech_postal_code") }}: </b>
                    {{ whois.tech_countryCode }}
                  </p>
                  <p v-if="whois.tech_email">
                    <b>{{ $t("website.tech_email") }}: </b>
                    {{ whois.tech_email }}
                  </p>
                  <p v-if="whois.tech_telephone">
                    <b>{{ $t("website.tech_phone") }}: </b>
                    {{ whois.tech_telephone }}
                  </p>
                  <p v-if="whois.tech_fax">
                    <b>{{ $t("website.tech_fax") }}: </b> {{ whois.tech_fax }}
                  </p>
                </div>
                <p class="text-center p-5" v-if="!whois && !results_whois">
                  <b-button
                    class="btn btn-sm"
                    @click="searchWhois"
                    variant="primary"
                    v-if="
                      id_user === id_analys ||
                      id_user === manager ||
                      user_type === 'superadmin' ||
                      user_type === 'admin' ||
                      user_type === 'vvip'
                    "
                    ><b-spinner
                      v-if="loading"
                      label="Loading ..."
                      small
                    ></b-spinner
                    ><span v-if="loading" class="ml-2">{{
                      $t("button.search.loading")
                    }}</span>
                    <span v-if="!loading"
                      ><i class="fas fa-search"></i>
                      {{ $t("website.get-data") }}
                    </span></b-button
                  >
                </p>
                <div v-if="results_whois">
                  <div class="mt-4">
                    <p v-if="results_whois.createdDate">
                      <b>{{ $t("website.created_date") }}: </b>
                      {{ formatDate(results_whois.createdDate) }}
                    </p>
                    <p v-if="results_whois.expiresDate">
                      <b>{{ $t("website.expired_date") }}: </b>
                      {{ formatDate(results_whois.expiresDate) }}
                    </p>
                    <p v-if="results_whois.contact_email">
                      <b>{{ $t("website.contact_email") }}: </b>
                      {{ results_whois.contact_email }}
                    </p>
                    <p v-if="results_whois.registrant_name">
                      <b>{{ $t("website.registran_name") }}: </b>
                      {{ results_whois.registrant_name }}
                    </p>
                    <p v-if="results_whois.registrant_organization">
                      <b>{{ $t("website.registrant_organization") }}: </b>
                      {{ results_whois.registrant_organization }}
                    </p>
                    <p v-if="results_whois.registrant_street">
                      <b>{{ $t("website.registran_street") }}: </b>
                      {{ results_whois.registrant_street }}
                    </p>
                    <p v-if="results_whois.registrant_city">
                      <b>{{ $t("website.registran_city") }}: </b>
                      {{ results_whois.registrant_city }}
                    </p>
                    <p v-if="results_whois.registrant_state">
                      <b>{{ $t("website.registran_state") }}: </b>
                      {{ results_whois.registrant_state }}
                    </p>
                    <p v-if="results_whois.registrant_postalCode">
                      <b>{{ $t("website.registran_postal_code") }}: </b>
                      {{ results_whois.registrant_postalCode }}
                    </p>
                    <p v-if="results_whois.registrant_host_contry">
                      <b>{{ $t("website.registran_country") }}: </b>
                      {{ results_whois.registrant_host_contry }}
                    </p>
                    <p v-if="results_whois.registrant_countryCode">
                      <b>{{ $t("website.registran_country") }}: </b>
                      {{ results_whois.registrant_countryCode }}
                    </p>
                    <p v-if="results_whois.registrant_email">
                      <b>{{ $t("website.registran_email") }}: </b>
                      {{ results_whois.registrant_email }}
                    </p>
                    <p v-if="results_whois.registrant_telephone">
                      <b>{{ $t("website.registran_phone") }}: </b>
                      {{ results_whois.registrant_telephone }}
                    </p>
                    <p v-if="results_whois.registrant_fax">
                      <b>{{ $t("website.registran_fax") }}: </b>
                      {{ results_whois.registrant_fax }}
                    </p>
                    <p v-if="results_whois.admin_name">
                      ======================================================
                    </p>
                    <p v-if="results_whois.admin_name">
                      <b>{{ $t("website.admin_name") }}: </b>
                      {{ results_whois.admin_name }}
                    </p>
                    <p v-if="results_whois.admin_organization">
                      <b>{{ $t("website.admin_organization") }}: </b>
                      {{ results_whois.admin_organization }}
                    </p>
                    <p v-if="results_whois.admin_street">
                      <b>{{ $t("website.admin_street") }}: </b>
                      {{ results_whois.admin_street }}
                    </p>
                    <p v-if="results_whois.admin_city">
                      <b>{{ $t("website.admin_city") }}: </b>
                      {{ results_whois.admin_city }}
                    </p>
                    <p v-if="results_whois.admin_state">
                      <b>{{ $t("website.admin_state_provincie") }}: </b>
                      {{ results_whois.admin_state }}
                    </p>
                    <p v-if="results_whois.admin_postalCode">
                      <b>{{ $t("website.admin_postal_code") }}: </b>
                      {{ results_whois.admin_postalCode }}
                    </p>
                    <p v-if="results_whois.admin_host_contry">
                      <b>{{ $t("website.admin_country") }}: </b>
                      {{ results_whois.admin_host_contry }}
                    </p>
                    <p v-if="results_whois.admin_countryCode">
                      <b>{{ $t("website.admin_postal_code") }}: </b>
                      {{ results_whois.admin_countryCode }}
                    </p>
                    <p v-if="results_whois.admin_email">
                      <b>{{ $t("website.admin_phone") }}: </b>
                      {{ results_whois.admin_email }}
                    </p>
                    <p v-if="results_whois.admin_telephone">
                      <b>{{ $t("website.admin_phone") }}: </b>
                      {{ results_whois.admin_telephone }}
                    </p>
                    <p v-if="results_whois.admin_fax">
                      <b>{{ $t("website.admin_fax") }}: </b>
                      {{ results_whois.admin_fax }}
                    </p>
                    <p v-if="results_whois.tech_name">
                      ======================================================
                    </p>
                    <p v-if="results_whois.tech_name">
                      <b>{{ $t("website.tech_name") }}: </b>
                      {{ results_whois.tech_name }}
                    </p>
                    <p v-if="results_whois.tech_organization">
                      <b>{{ $t("website.tech_organization") }}: </b>
                      {{ results_whois.tech_organization }}
                    </p>
                    <p v-if="results_whois.tech_street">
                      <b>{{ $t("website.tech_street") }}: </b>
                      {{ results_whois.tech_street }}
                    </p>
                    <p v-if="results_whois.tech_city">
                      <b>{{ $t("website.tech_city") }}: </b>
                      {{ results_whois.tech_city }}
                    </p>
                    <p v-if="results_whois.tech_state">
                      <b>{{ $t("website.tech_state_province") }}: </b>
                      {{ results_whois.tech_state }}
                    </p>
                    <p v-if="results_whois.tech_postalCode">
                      <b>{{ $t("website.tech_postal_code") }}: </b>
                      {{ results_whois.tech_postalCode }}
                    </p>
                    <p v-if="results_whois.tech_host_contry">
                      <b>{{ $t("website.tech_country") }}: </b>
                      {{ results_whois.tech_host_contry }}
                    </p>
                    <p v-if="results_whois.tech_countryCode">
                      <b>{{ $t("website.tech_postal_code") }}: </b>
                      {{ results_whois.tech_countryCode }}
                    </p>
                    <p v-if="results_whois.tech_email">
                      <b>{{ $t("website.tech_email") }}: </b>
                      {{ results_whois.tech_email }}
                    </p>
                    <p v-if="results_whois.tech_telephone">
                      <b>{{ $t("website.tech_phone") }}: </b>
                      {{ results_whois.tech_telephone }}
                    </p>
                    <p v-if="results_whois.tech_fax">
                      <b>{{ $t("website.tech_fax") }}: </b>
                      {{ results_whois.tech_fax }}
                    </p>
                  </div>
                  <!-- <div class="text-left">
                                  <b-button class="btn" variant="secondary" size="sm" @click="clearData"><i class="fa fa-times"></i> Clear</b-button> <b-button class="btn" variant="success" size="sm" @click="saveWhois"><i class="fa fa-check"></i> Save</b-button>
                              </div>  -->
                </div>
              </div>
            </b-tab>

            <b-tab title="Sub Domain">
              <div class="card h-100">
                <div class="py-4" v-if="subdomain">
                  <b class="mt-2">Sub Domain</b>
                  <p
                    v-for="data in JSON.parse(subdomain)"
                    :key="data.ip"
                    class="mt-2"
                  >
                    <span>
                      {{ data.subdomain }} :
                      <span class="text-success">( {{ data.ip }} )</span></span
                    >
                  </p>
                </div>
                <p
                  class="text-center p-5"
                  v-if="!subdomain && !results_subdomain"
                >
                  <b-button
                    class="btn btn-sm"
                    @click="searchSubdomain"
                    variant="primary"
                    v-if="
                      id_user === id_analys ||
                      id_user === manager ||
                      user_type === 'superadmin' ||
                      user_type === 'admin' ||
                      user_type === 'vvip'
                    "
                    ><b-spinner v-if="loading" label="Loading ..." small>
                    </b-spinner
                    ><span v-if="loading" class="ml-2">{{
                      $t("button.search.loading")
                    }}</span>
                    <span v-if="!loading"
                      ><i class="fas fa-search"></i>
                      {{ $t("website.get-data") }}
                    </span></b-button
                  >
                </p>
                <div v-if="results_subdomain">
                  <div class="mt-4">
                    <b class="mt-2">Sub Domain</b>
                    <p
                      v-for="data in results_subdomain"
                      :key="data.subdomain"
                      class="mt-2"
                    >
                      <span>
                        {{ data.subdomain }} :
                        <span class="text-success"
                          >( {{ data.ip }} )</span
                        ></span
                      >
                    </p>
                  </div>
                  <!-- <div class="text-left">
                                        <b-button class="btn" variant="secondary" size="sm" @click="clearData"><i class="fa fa-times"></i> Clear</b-button> <b-button class="btn" variant="success" size="sm" @click="saveSubdomain"><i class="fa fa-check"></i> Save</b-button>
                                    </div>  -->
                </div>
              </div>
            </b-tab>

            <b-tab title="Web Service">
              <div class="card h-100">
                <div class="py-4" v-if="service">
                  <p v-if="service.domain_name">
                    <b>{{ $t("website.domain_name") }} : </b>
                    {{ service.domain_name }}
                  </p>
                  <p v-if="service.ftp">
                    <b>FTP (Port : 21 ) : </b
                    ><span v-if="service.ftp == 'Open'" class="text-success">
                      {{ service.ftp }}</span
                    ><span v-else> {{ service.ftp }}</span>
                  </p>
                  <p v-if="service.ssh">
                    <b>SSH ( Port : 22 ) : </b>
                    <span v-if="service.ssh == 'Open'" class="text-success">
                      {{ service.ssh }}</span
                    ><span v-else> {{ service.ssh }}</span>
                  </p>
                  <p v-if="service.dns">
                    <b>Telnet ( Port : 23 ) : </b>
                    <span v-if="service.telnet == 'Open'" class="text-success">
                      {{ service.telnet }}</span
                    ><span v-else> {{ service.telnet }}</span>
                  </p>
                  <p v-if="service.smtp">
                    <b>SMTP ( Port :25 ) : </b>
                    <span v-if="service.smtp == 'Open'" class="text-success">
                      {{ service.smtp }}</span
                    ><span v-else> {{ service.smtp }}</span>
                  </p>
                  <p v-if="service.whois">
                    <b>WHOIS ( Port : 43 ) : </b>
                    <span v-if="service.whois == 'Open'" class="text-success">
                      {{ service.whois }}</span
                    ><span v-else> {{ service.whois }}</span>
                  </p>
                  <p v-if="service.dns">
                    <b>DNS ( Port : 53 ) : </b
                    ><span v-if="service.dns == 'Open'" class="text-success">
                      {{ service.dns }}</span
                    ><span v-else> {{ service.dns }}</span>
                  </p>
                  <p v-if="service.dhcp">
                    <b>DHCP ( Port : 68 ) : </b>
                    <span v-if="service.dhcp == 'Open'" class="text-success">
                      {{ service.dhcp }}</span
                    ><span v-else> {{ service.dhcp }}</span>
                  </p>
                  <p v-if="service.http">
                    <b>HTTP ( Port : 80 ) : </b>
                    <span v-if="service.http == 'Open'" class="text-success">
                      {{ service.http }}</span
                    ><span v-else> {{ service.http }}</span>
                  </p>
                  <p v-if="service.pop3">
                    <b>POP3 ( Port : 110 ) : </b>
                    <span v-if="service.pop3 == 'Open'" class="text-success">
                      {{ service.pop3 }}</span
                    ><span v-else> {{ service.pop3 }}</span>
                  </p>
                  <p v-if="service.sftp">
                    <b>SFTP ( Port : 115 ) : </b
                    ><span v-if="service.sftp == 'Open'" class="text-success">
                      {{ service.sftp }}</span
                    ><span v-else> {{ service.sftp }}</span>
                  </p>
                  <p v-if="service.nntp">
                    <b>NNTP ( Port : 119 ) : </b>
                    <span v-if="service.nntp == 'Open'" class="text-success">
                      {{ service.nntp }}</span
                    ><span v-else> {{ service.nntp }}</span>
                  </p>
                  <p v-if="service.ntp">
                    <b>NTP ( Port : 123 ) : </b>
                    <span v-if="service.ntp == 'Open'" class="text-success">
                      {{ service.ntp }}</span
                    ><span v-else> {{ service.ntp }}</span>
                  </p>
                  <p v-if="service.netbios">
                    <b>NETBIOS ( Port : 139 ) : </b
                    ><span
                      v-if="service.netbios == 'Open'"
                      class="text-success"
                    >
                      {{ service.netbios }}</span
                    ><span v-else> {{ service.netbios }}</span>
                  </p>
                  <p v-if="service.imap">
                    <b>IMAP ( Port : 143 ) : </b
                    ><span v-if="service.imap == 'Open'" class="text-success">
                      {{ service.imap }}</span
                    ><span v-else> {{ service.imap }}</span>
                  </p>
                  <p v-if="service.snmp">
                    <b>SNMP ( Port : 161 ) : </b
                    ><span v-if="service.snmp == 'Open'" class="text-success">
                      {{ service.snmp }}</span
                    ><span v-else> {{ service.snmp }}</span>
                  </p>
                  <p v-if="service.imap3">
                    <b>IMAP3 ( Port : 220 ) : </b>
                    <span v-if="service.imap3 == 'Open'" class="text-success">
                      {{ service.imap3 }}</span
                    ><span v-else> {{ service.imap3 }}</span>
                  </p>
                  <p v-if="service.idap">
                    <b>IDAP ( Port : 389 ) : </b
                    ><span v-if="service.idap == 'Open'" class="text-success">
                      {{ service.idap }}</span
                    ><span v-else> {{ service.idap }}</span>
                  </p>
                  <p v-if="service.ssl">
                    <b>SSL ( Port : 443 ) : </b>
                    <span v-if="service.ssl == 'Open'" class="text-success">
                      {{ service.ssl }}</span
                    ><span v-else> {{ service.ssl }}</span>
                  </p>
                  <p v-if="service.oracle_sql">
                    <b>ORACLE SQL ( Port : 1521 ) : </b>
                    <span
                      v-if="service.oracle_sql == 'Open'"
                      class="text-success"
                    >
                      {{ service.oracle_sql }}</span
                    ><span v-else> {{ service.oracle_sql }}</span>
                  </p>
                  <p v-if="service.nfs">
                    <b>NFS ( Port : 2049 ) : </b>
                    <span v-if="service.nfs == 'Open'" class="text-success">
                      {{ service.nfs }}</span
                    ><span v-else> {{ service.nfs }}</span>
                  </p>
                  <p v-if="service.mysql">
                    <b>MYSQL ( Port : 3306 ) : </b>
                    <span v-if="service.mysql == 'Open'" class="text-success">
                      {{ service.mysql }}</span
                    ><span v-else> {{ service.mysql }}</span>
                  </p>
                  <p v-if="service.vnc">
                    <b>VNC ( Port : 5800 ) : </b>
                    <span v-if="service.vnc == 'Open'" class="text-success">
                      {{ service.vnc }}</span
                    ><span v-else> {{ service.vnc }}</span>
                  </p>
                  <p v-if="service.http2">
                    <b>HTTP2 ( Port : 8080 ) : </b>
                    <span v-if="service.http2 == 'Open'" class="text-success">
                      {{ service.http2 }}</span
                    ><span v-else> {{ service.http2 }}</span>
                  </p>
                </div>
                <p class="text-center p-5" v-if="!service && !results_service">
                  <b-button
                    class="btn btn-sm"
                    @click="searchWebServer"
                    variant="primary"
                    v-if="
                      id_user === id_analys ||
                      id_user === manager ||
                      user_type === 'superadmin' ||
                      user_type === 'admin' ||
                      user_type === 'vvip'
                    "
                  >
                    <b-spinner
                      v-if="loading"
                      label="Loading ..."
                      small
                    ></b-spinner
                    ><span v-if="loading" class="ml-2">{{
                      $t("button.search.loading")
                    }}</span>
                    <span v-if="!loading"
                      ><i class="fas fa-search"></i>
                      {{ $t("website.get-data") }}
                    </span></b-button
                  >
                </p>
                <div v-if="results_service">
                  <div class="mt-4">
                    <div class="row mt-2 mx-3" v-if="results_service">
                      <table class="table px-4">
                        <thead>
                          <tr>
                            <td>
                              <b>{{ $t("website.name") }} </b>
                            </td>
                            <td>
                              <b>Port </b>
                            </td>
                            <td>
                              <b>Status </b>
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="service in results_service"
                            :key="service.id_web_service"
                          >
                            <td>
                              {{ service.name }}
                            </td>
                            <td>
                              {{ service.port }}
                            </td>
                            <td>
                              <span
                                v-if="service.status == 'Open'"
                                class="text-success"
                              >
                                {{ service.status }}
                              </span>
                              <span
                                v-if="service.status == 'Close'"
                                class="text-danger"
                              >
                                {{ service.status }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="text-left">
                    <!-- <b-button class="btn" variant="secondary" size="sm" @click="clearData"><i class="fa fa-times"></i> Clear</b-button> <b-button class="btn" variant="success" size="sm" @click="saveWebService"><i class="fa fa-check"></i> Save</b-button> -->
                  </div>
                </div>
              </div>
            </b-tab>

            <b-tab title="CMS">
              <div class="card h-100">
                <div class="py-4" v-if="cms">
                  <div class="">
                    <b class="mb-3 mt-2" v-if="cms.result">CMS</b>
                    <p v-for="data in JSON.parse(cms.result)" :key="data.name">
                      <span>
                        {{ data.name }}:
                        <span class="text-success"
                          >( {{ data.categories[0] }} )</span
                        ></span
                      >
                    </p>
                  </div>
                  <div class="" v-if="JSON.parse(cms.social_media)[0]">
                    <b class="mb-3">{{ $t("website.social_media") }}</b>
                    <p
                      v-for="data in JSON.parse(cms.social_media)"
                      :key="data.network"
                    >
                      <span>
                        {{ data.network }}:
                        <a
                          :href="data.url"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="text-success"
                        >
                          ( {{ data.profile }} )</a
                        ></span
                      >
                    </p>
                  </div>
                </div>
                <p class="text-center p-5" v-if="!results_cms && !cms">
                  <b-button
                    class="btn btn-sm"
                    variant="primary"
                    @click="searchCMS"
                    v-if="
                      id_user === id_analys ||
                      id_user === manager ||
                      user_type === 'superadmin' ||
                      user_type === 'admin' ||
                      user_type === 'vvip'
                    "
                  >
                    <b-spinner
                      v-if="loading"
                      label="Loading ..."
                      small
                    ></b-spinner
                    ><span v-if="loading" class="ml-2">{{
                      $t("button.search.loading")
                    }}</span>
                    <span v-if="!loading"
                      ><i class="fas fa-search"></i>
                      {{ $t("website.get-data") }}
                    </span></b-button
                  >
                </p>
                <div v-if="results_cms" class="mt-3">
                  <label v-if="cms_results"
                    ><b>{{ $t("website.result") }}:</b></label
                  >
                  <p v-for="data in cms_results" :key="data.name">
                    <span>
                      {{ data.name }}:
                      <span class="text-success">{{
                        data.categories
                      }}</span></span
                    >
                  </p>

                  <label v-if="sm_results" class="mt-3"
                    ><b>{{ $t("website.social_media") }}:</b></label
                  >
                  <p v-for="data in sm_results" :key="data.name">
                    <span>
                      {{ data.network }}:
                      <a
                        :href="data.url"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="text-success"
                      >
                        [ {{ data.profile }} ]</a
                      ></span
                    >
                  </p>
                  <div class="text-left">
                    <!-- <b-button class="btn" variant="secondary" size="sm" @click="clearData"><i class="fa fa-times"></i> Clear</b-button> <b-button class="btn" variant="success" size="sm" @click="saveWebCms"><i class="fa fa-check"></i> Save</b-button> -->
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
        <div v-if="loadingnew" class="mt-4 mx-auto p-5">
          <div class="text-center">
            <div
              class="spinner-border text-secondary"
              role="status"
              v-if="loadingnew"
            >
              <span class="sr-only"
                ><p>{{ $t("website.website-info") }}</p></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import SocmedService from "@/helpers/socmed.service";
import { gmapApi } from "vue2-google-maps";
import TargetService from "@/helpers/target-profile.service";
import WebsiteService from "@/helpers/website.service.js";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  props: ["id_target", "id_analys", "manager", "id_user", "user_type"],
  // page: {
  //   title: "Website",
  //   meta: [{ name: "description" }]
  // },

  data() {
    return {
      id: this.id_target,
      domaine_name: "",
      loading: "",
      loadingnew: false,
      results_cms: "",
      website: "",
      webinfo: "",
      cms: "",
      subdomain: "",
      service: "",
      iplocation: "",
      results_location: "",
      results_service: "",
      results_whois: "",
      results_subdomain: "",
      cms_results: "",
      sm_results: "",
      title: "Website",
      whois: "",
      markers: [
        {
          position: { lat: 10.0, lng: 10.0 },
        },
        {
          position: { lat: 15.0, lng: 13.0 },
        },
      ],
    };
  },
  computed: {
    google: gmapApi,
  },
  watch: {
    address: {
      handler: function (n, o) {
        // console.log(JSON.stringify(n));
        this.count1 = n.count;
      },
      deep: true,
    },
  },
  methods: {
    async getTargetDetail() {
      this.loadingnew = true;
      await TargetService.getDetailTarget(this.id)
        .then((response) => {
          // console.log(response);
          this.domaine_name = response.data.data.private_web[0].webinfo.domain_name;
          this.website = response.data.data.private_web[0];
          this.webinfo = response.data.data.private_web[0].webinfo;
          this.iplocation = response.data.data.private_web[0].iplocation;
          this.whois = response.data.data.private_web[0].whois;
          this.service = response.data.data.private_web[0].service;
          this.cms = response.data.data.private_web[0].cms;
          this.getWebsiteDetail();

          this.searchLocation();
          this.searchSubdomain();
          this.searchWhois();
          this.searchCMS();
          this.searchWebServer();
          this.loadingnew = false;
        })
        .catch((err) => {
          console.log("d target -> ", err);
          this.loadingnew = false;
        });
    },

    getWebsiteDetail() {
      this.loading = true;
      WebsiteService.getWebInfoDetail(this.webinfo.id_web_info)
        .then((response) => {
          this.subdomain = response.data.data.subdomain.subdomain;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    searchSubdomain() {
      (this.loading = true), (this.search = true);
      this.SearchResult = "";
      const data = {
        website: this.webinfo.domain_name,
      };
      WebsiteService.searchSubDomain(data)
        .then((response) => {
          this.results_subdomain = response.data.output;
          this.loading = false;
          if (this.results_subdomain) {
            this.saveSubdomain();
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    saveSubdomain() {
      var data = {
        id_web_info: this.webinfo.id_web_info,
        subdomain: JSON.stringify(this.results_subdomain),
      };
      // console.log(data);
      WebsiteService.createSubDomain(data)
        .then((response) => {
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    searchLocation() {
      (this.loading = true), (this.search = true);
      this.SearchResult = "";
      const data = {
        website: this.domaine_name,
      };
      // console.log('mulai', data);
      WebsiteService.searchDomainLocation(data)
        .then((response) => {
          this.results_location = response.data.output;
          if (this.results_location) {
            this.saveWebsiteInfoLocation();
          }
          // console.log(results_location);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    saveWebsiteInfoLocation() {
      var data = {
        id_private_web: this.website.id_private_web,
        domain_name: this.webinfo.domain_name,
        ip_address: this.results_location.ip,
        version: this.results_location.version,
        city: this.results_location.city,
        region: this.results_location.region,
        region_code: this.results_location.region_code,
        country: this.results_location.country,
        country_name: this.results_location.country_name,
        country_code: this.results_location.country_code,
        country_code_iso3: this.results_location.country_code_iso3,
        country_capital: this.results_location.country_code_iso3,
        country_tld: this.results_location.country_tld,
        continent_code: this.results_location.continent_code,
        in_ue: this.results_location.in_eu,
        postal_code: this.results_location.postal,
        latitude: this.results_location.latitude,
        longitude: this.results_location.longitude,
        timezone: this.results_location.timezone,
        utc_offset: this.results_location.ip,
        country_calling_code: this.results_location.ip,
        currency: this.results_location.currency,
        currency_name: this.results_location.currency_name,
        languages: this.results_location.languages,
        country_area: this.results_location.country_area,
        country_population: this.results_location.country_population,
        asn: this.results_location.asn,
        org: this.results_location.org,
      };
      WebsiteService.createWebInfoLocation(data)
        .then((response) => {
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    searchWhois() {
      (this.loading = true), (this.search = true);
      this.SearchResult = "";
      const data = {
        website: this.webinfo.domain_name,
      };
      WebsiteService.searchDomainWhois(data)
        .then((response) => {
          this.results_whois = response.data.output;
          if (this.results_whois) {
            this.saveWhois();
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    saveWhois() {
      var data = {
        id_private_web: this.website.id_private_web,
        domain_name: this.results_whois.domainName,
        created_date: this.results_whois.createdDate,
        expired_date: this.results_whois.expiresDate,
        contact_email: this.results_whois.contact_email,
        registran_name: this.results_whois.registrant_name,
        registran_organization: this.results_whois.registrant_organization,
        registran_street: this.results_whois.registrant_street,
        registran_city: this.results_whois.registrant_city,
        registran_state: this.results_whois.registrant_state,
        registran_postal_code: this.results_whois.registrant_postalCode,
        registran_country: this.results_whois.registrant_host_contry,
        registran_email: this.results_whois.registrant_email,
        registran_phone: this.results_whois.registrant_telephone,
        registran_fax: this.results_whois.registrant_fax,
        admin_name: this.results_whois.admin_name,
        admin_organization: this.results_whois.admin_organization,
        admin_street: this.results_whois.admin_street,
        admin_city: this.results_whois.admin_city,
        admin_state_province: this.results_whois.admin_city,
        admin_postal_code: this.results_whois.admin_postalCode,
        admin_country: this.results_whois.admin_countryCode,
        admin_email: this.results_whois.admin_email,
        admin_phone: this.results_whois.admin_telephone,
        admin_fax: this.results_whois.admin_fax,
        tech_name: this.results_whois.tech_name,
        tech_organization: this.results_whois.tech_organization,
        tech_street: this.results_whois.tech_street,
        tech_city: this.results_whois.tech_city,
        tech_state_province: this.results_whois.tech_state,
        tech_postal_code: this.results_whois.tech_postalCode,
        tech_country: this.results_whois.tech_host_contry,
        tech_email: this.results_whois.tech_email,
        tech_phone: this.results_whois.tech_telephone,
        tech_fax: this.results_whois.tech_fax,
      };
      WebsiteService.createWebWhois(data)
        .then((response) => {
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    searchWebServer() {
      (this.loading = true), (this.search = true);
      this.SearchResult = "";
      const data = {
        website: this.webinfo.domain_name,
      };
      // console.log(this.loading);
      WebsiteService.searchWebService(data)
        .then((response) => {
          this.results_service = response.data.output;
          // console.log(this.loading);
          if (this.results_service) {
            this.saveWebService();
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    saveWebService() {
      var data = {
        id_private_web: this.website.id_private_web,
        domain_name: this.webinfo.domain_name,
        ftp: this.results_service[0].status,
        ssh: this.results_service[1].status,
        telnet: this.results_service[2].status,
        smtp: this.results_service[3].status,
        whois: this.results_service[4].status,
        dns: this.results_service[5].status,
        dhcp: this.results_service[6].status,
        http: this.results_service[7].status,
        pop3: this.results_service[8].status,
        sftp: this.results_service[9].status,
        nntp: this.results_service[10].status,
        ntp: this.results_service[11].status,
        netbios: this.results_service[12].status,
        imap: this.results_service[13].status,
        snmp: this.results_service[14].status,
        imap3: this.results_service[15].status,
        ldap: this.results_service[16].status,
        ssl: this.results_service[17].status,
        oracle_sql: this.results_service[18].status,
        nfs: this.results_service[19].status,
        mysql: this.results_service[20].status,
        vnc: this.results_service[21].status,
        http2: this.results_service[22].status,
      };
      WebsiteService.createWebService(data)
        .then((response) => {
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    searchCMS() {
      (this.loading = true), (this.search = true);
      this.results_cms = "";
      const data = {
        website: this.webinfo.domain_name,
      };
      WebsiteService.searchWebCms(data)
        .then((response) => {
          this.results_cms = response.data.output;
          this.cms_results = response.data.output.result;
          this.sm_results = response.data.output.social_media;
          if (this.results_cms) {
            this.saveWebCms();
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    saveWebCms() {
      var data = {
        id_private_web: this.website.id_private_web,
        domain_name: this.webinfo.domain_name,
        result: JSON.stringify(this.results_cms.result),
        social_media: JSON.stringify(this.results_cms.social_media),
      };
      WebsiteService.createWebCmsChecker(data)
        .then((response) => {
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    geocodedAddress() {
      const geocoder = this.google && new google.maps.Geocoder();
      geocoder.geocode({ address: this.address }, function (results, status) {
        // console.log('geocode->',results[0].geometry.location.lat());
      });
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },

    clearData() {
      this.SearchResult = "";
      this.searchKey = "";
      this.results_whois = "";
      this.results_location = "";
      this.results_service = "";
      this.results_cms = "";
      this.results_subdomain = "";
    },

    deletePrivateWeb(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          WebsiteService.deletePrivateWebsite(id)
            .then((response) => {
              this.getTargetDetail();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Data Deleted Success",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
  },
  mounted() {
    this.getTargetDetail();
    this.$watch(
      () => this.openMap,
      () => {
        if (this.openMap == true) {
          console.log(this.latlong);
          this.geocodedAddress();
        }
      }
    );
  },
};
</script>